import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import SubscriptionDetails from 'containers/subscriptions/subscription-details/SubscriptionDetails';
import InvestorsTable from './InvestorsTable';
import { ListContainer } from 'components';

const Investors = () => {
    return (
        <ListContainer>
            <Routes>
                <Route path="details/:userId/:subscriptionId" element={<SubscriptionDetails />} />
                <Route index element={<InvestorsTable />} />
                <Route path="*" element={<Navigate to="/investors" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default Investors;
